/**
 * Order
 * Order APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionStatus = 'PENDING' | 'ACTIVE' | 'CLOSED';

export const SubscriptionStatus = {
    Pending: 'PENDING' as SubscriptionStatus,
    Active: 'ACTIVE' as SubscriptionStatus,
    Closed: 'CLOSED' as SubscriptionStatus
};

